import { all } from "redux-saga/effects";
import sellerSaga from './sellerSaga';
import subSellerSaga from './subSellerSaga';
import userSaga from './userSaga';
import paymentSaga from './paymentSaga';


function * watcherSaga() {
    yield all([sellerSaga(), subSellerSaga(), userSaga(), paymentSaga()]);
}

export default watcherSaga